import { combineReducers } from "redux";

import groupProgramsReducer from './store/programs';

const programReducer = combineReducers({
    groupPrograms: groupProgramsReducer
});

export default programReducer;